export enum EstadoOfertaCredito 
{
  PendienteSupervisor = "Pendiente Supervisor",
  AprobadaSupervisor = "Aprobada Supervisor",
  RechazadaSupervisor = "Rechazada Supervisor",
  AceptadaCliente = "Aceptada Cliente", 
  NoSelecionada = "No Seleccionada",
  Borrador = "Borrador",
  AnuladaPorContraoferta = "Anulada por Contraoferta"
  }